import React, { useEffect, useState } from "react";
import { FormListProps } from "interfaces/forms/FormListProps";
import { ApiService } from "services/ApiService";
import { FormDto } from "models/forms/FormDto";
import { Form } from "models/forms/Form";

const FormList: React.FC<FormListProps> = ({
  ownerId,
  onCreateNew,
  onSelect: onClick,
  useDtos,
  formListCount,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [formList, setFormList] = useState<FormDto[] | Form[]>([]);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const response = await ApiService.getForms(ownerId, useDtos);

        if (response.success && response.data) setFormList(response.data);
      } catch (error) {
        console.error("Error fetching forms:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchForms();
  }, [ownerId, useDtos, formListCount]);

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="p-5">
      <h2 className="text-xl font-semibold text-center">Forms</h2>

      {formList.length > 0 ? (
        <div className="grid gap-5 mt-5 grid-cols-[repeat(auto-fit,minmax(250px,1fr))]">
          {formList.map((form) => (
            <div
              key={form.id}
              onClick={() => onClick(useDtos ? form.id : (form as Form))}
              className="w-full border border-gray-300 rounded-xl p-5 bg-white text-center shadow-md cursor-pointer transform transition-transform duration-200 hover:scale-105 hover:shadow-lg"
            >
              <h4 className="text-md font-medium my-2 break-words">{form.name}</h4>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-center mt-5 text-gray-500">No forms found.</p>
      )}

      {useDtos && (
        <div className="text-center mt-6">
          <button
            onClick={onCreateNew}
            className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
          >
            Create New Form
          </button>
        </div>
      )}
    </div>
  );

};

export default FormList;
